<template>
    <div
        id="miei-dati"
        v-bind:class="[showAuthPopup ? 'bg-light popup-aperto' : 'bg-light']"
    >
        <div class="body-wrapper">
            <gallery-header />
            <main>
                <div class="container-fluid mt-5">
                    <div class="row d-flex justify-content-between flex-wrap align-items-center">
                        <div class="col-sm-8">
                            <h2 class="mb-0 text-uppercase">{{$t('I miei dati')}}</h2>
                        </div>
                    </div>
                    <ValidationObserver v-slot="{ handleSubmit }">
                        <form
                            ref="form"
                            class="mt-3"
                            @submit.prevent="handleSubmit(onSubmit)"
                        >
                            <fieldset>
                                <div class="form-row">
                                    <div class="col-sm-6 mb-3">
                                        <label for="name">{{$t('Nome')}} <span class="text-danger">*</span></label>
                                        <validation-provider
                                            rules="required"
                                            v-slot="{ errors }"
                                        >
                                            <input
                                                type="text"
                                                name="name"
                                                class="form-control rounded-pill rilievo-ombra-interna"
                                                id="name"
                                                v-model="user.firstName"
                                            />
                                            <span class="text-danger">{{errors[0]}}</span>
                                        </validation-provider>
                                    </div>
                                    <div class="col-sm-6 mb-3">
                                        <label for="lastname">{{$t('Cognome')}} <span class="text-danger">*</span></label>
                                        <validation-provider
                                            rules="required"
                                            v-slot="{ errors }"
                                        >
                                            <input
                                                type="text"
                                                name="lastname"
                                                class="form-control rounded-pill rilievo-ombra-interna"
                                                id="lastname"
                                                v-model="user.lastName"
                                            >
                                            <span class="text-danger">{{errors[0]}}</span>
                                        </validation-provider>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="col-sm-6 mb-3">
                                        <label for="email">{{$t('Email')}} <span class="text-danger">*</span></label>
                                        <validation-provider
                                            rules="required|validEmail|confirmed:@email"
                                            mode="passive"
                                            :debounce="5"
                                            v-slot="{ touched, invalid, pending, errors, validate }"
                                            vid="email"
                                        >
                                            <b-form-input
                                                type="email"
                                                name="email"
                                                id="email"
                                                v-model="user.email"
                                                :class="{'rounded-pill rilievo-ombra-interna': true, 'is-invalid': touched && !pending && invalid, 'validating': pending}"
                                                @change="validate()"
                                            >
                                            </b-form-input>
                                            <span class="text-danger">{{errors[0]}}</span>
                                        </validation-provider>
                                    </div>
                                    <div class="col-sm-6 mb-3">
                                        <label for="email-check">{{$t('Conferma email')}} <span class="text-danger">*</span></label>
                                        <validation-provider
                                            name="Email Confirmation"
                                            rules="required|email"
                                            v-slot="{ errors }"
                                            vid="email"
                                        >
                                            <input
                                                type="email"
                                                name="emailConfirm"
                                                class="form-control rounded-pill rilievo-ombra-interna"
                                                v-model="checkMail"
                                            />
                                            <span class="text-danger">{{errors[0]}}</span>
                                        </validation-provider>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="col-sm-6 mb-3">
                                        <label for="password">{{$t('Password')}} <span class="text-danger">*</span></label>
                                        <validation-provider
                                            rules="confirmed:@passwd"
                                            v-slot="{ errors }"
                                        >
                                            <input
                                                type="password"
                                                name="password"
                                                class="form-control rounded-pill rilievo-ombra-interna"
                                                v-model="password"
                                            >
                                            <span class="text-danger">{{errors[0]}}</span>
                                        </validation-provider>
                                    </div>
                                    <div class="col-sm-6 mb-3">
                                        <label for="password-check">{{$t('Conferma password')}} <span class="text-danger">*</span></label>
                                        <validation-provider
                                            rules=""
                                            v-slot="{ errors }"
                                            vid="passwd"
                                        >
                                            <input
                                                type="password"
                                                name="passwordConfirm"
                                                class="form-control rounded-pill rilievo-ombra-interna"
                                                v-model="checkPassword"
                                            >
                                            <span class="text-danger">{{errors[0]}}</span>
                                        </validation-provider>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="col-sm-6 mb-3">
                                        <label for="indirizzo">{{$t('Indirizzo')}} <span class="text-danger">*</span></label>
                                        <validation-provider
                                            rules="required"
                                            v-slot="{ errors }"
                                        >
                                            <input
                                                type="text"
                                                name="indirizzo"
                                                class="form-control rounded-pill rilievo-ombra-interna"
                                                id="indirizzo"
                                                v-model="user.address"
                                            >
                                            <span class="text-danger">{{errors[0]}}</span>
                                        </validation-provider>
                                    </div>
                                    <div class="col-sm-6 mb-3">
                                        <label for="paese">{{$t('Nazione')}} <span class="text-danger">*</span></label>
                                        <validation-provider
                                            rules="required"
                                            v-slot="{ errors }"
                                        >
                                            <select
                                                name="paese"
                                                id="paese"
                                                class="form-control rounded-pill rilievo-ombra-interna"
                                                v-model="user.state"
                                                @change="onChangeCountry"
                                            >

                                                <option value="">{{$t('Seleziona nazione')}}</option>
                                                <option
                                                    v-for="country in countryList"
                                                    :key="country.id"
                                                    :value="country.name"
                                                >{{country.name}}</option>
                                            </select>
                                            <span class="text-danger">{{errors[0]}}</span>
                                        </validation-provider>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="col-sm-6 mb-3">
                                        <label for="province">{{$t('Provincia')}} <span class="text-danger">*</span></label>
                                        <validation-provider
                                            rules="required"
                                            v-slot="{ errors }"
                                        >
                                            <select
                                                name="province"
                                                ref="province"
                                                class="form-control rounded-pill rilievo-ombra-interna"
                                                v-model="user.province"
                                                @change="onChangeProvince"
                                            >
                                                <option value="">{{$t('Seleziona provincia')}}</option>
                                                <option
                                                    v-for="province in provincesList"
                                                    v-bind:key="province.Sigla"
                                                    v-bind:value="province.Sigla"
                                                    v-bind:selected="province.Sigla === user.province"
                                                >
                                                    {{province.Provincia}}
                                                </option>
                                            </select>
                                            <span class="text-danger">{{errors[0]}}</span>
                                        </validation-provider>
                                    </div>
                                    <div class="col-sm-6 mb-3">
                                        <label for="city">{{$t('Città')}} <span class="text-danger">*</span></label>
                                        <validation-provider
                                            rules="required"
                                            v-slot="{ errors }"
                                        >
                                            <select
                                                name="city"
                                                ref="city"
                                                class="form-control rounded-pill rilievo-ombra-interna"
                                                @change="onChangeCity"
                                                v-model="user.city"
                                            >
                                                <option value="">{{$t('Seleziona città')}}</option>
                                                <option
                                                    v-for="(key, value) in citiesList"
                                                    v-bind:key="value"
                                                    v-bind:value="value"
                                                    v-bind:selected="value === user.city"
                                                >
                                                    {{value}}
                                                </option>
                                            </select>
                                            <span class="text-danger">{{errors[0]}}</span>
                                        </validation-provider>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="col-sm-6 mb-3">
                                        <label for="zip">{{$t('CAP')}} <span class="text-danger">*</span></label>
                                        <validation-provider
                                            rules="required"
                                            v-slot="{ errors }"
                                        >
                                            <select
                                                name="zip"
                                                ref="zip"
                                                class="form-control rounded-pill rilievo-ombra-interna"
                                                v-model="user.postalCode"
                                            >
                                                <option value="">{{$t('Seleziona cap')}}</option>
                                                <option
                                                    v-for="zip in zipList"
                                                    v-bind:key="zip.cap"
                                                    v-bind:value="zip.cap"
                                                    v-bind:selected="zip.cap === user.postalCode"
                                                >
                                                    {{zip.cap}}
                                                </option>
                                            </select>
                                            <span class="text-danger">{{errors[0]}}</span>
                                        </validation-provider>
                                    </div>
                                    <div class="col-sm-6 mb-3">
                                        <label for="tel">{{$t('Telefono')}}</label>
                                        <input
                                            type="tel"
                                            name="tel"
                                            class="form-control rounded-pill rilievo-ombra-interna"
                                            id="tel"
                                            v-model="user.tel"
                                        >
                                    </div>
                                </div>
                            </fieldset>

                            <div class="d-flex justify-content-end mt-3">
                                <button
                                    class="btn btn-primary btn-rikorda2 mr-2"
                                    @click.prevent="onCancel"
                                >
                                    {{ $t("Annulla") }}
                                </button>
                                <button
                                    class="btn btn-primary btn-rikorda1"
                                    ref="save"
                                    type="submit"
                                >
                                    {{ $t("Salva") }}
                                </button>
                            </div>
                        </form>
                    </ValidationObserver>

                </div>

            </main>
            <gallery-footer />
        </div>
        <gallery-popup-login
            v-if="showAuthPopup"
            :username="checkMail"
            @login="onUserLogin"
            @close="onUserLoginClose"
        />
    </div>
</template>

<script>
import GalleryHeader from "../../components/gallery/Header";
import GalleryFooter from "../../components/gallery/Footer";
import GalleryPopupLogin from "../../components/gallery/PopupLogin";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required, email, confirmed } from "vee-validate/dist/rules";

export default {
    name: "AccountProfile",
    components: {
        GalleryFooter,
        GalleryHeader,
        GalleryPopupLogin,
        ValidationProvider,
        ValidationObserver
    },
    data() {
        return {
            user: {},
            tempUser: {},
            checkMail: "",
            password: "",
            checkPassword: "",
            countryList: [{ id: "Italia", name: "Italia" }],
            provincesList: [],
            citiesList: {},
            zipList: [],
            needsEmptyCity: false,
            needsEmptyZip: false,
            showAuthPopup: false
        };
    },
    mounted() {
        this.$store
            .dispatch("GET_ACCOUNT_PROFILE")
            .then((result) => {
                console.debug("GET_ACCOUNT_PROFILE", result);
                // parcheggia lo user in una variabile temporanea
                this.tempUser = result.user;
                this.checkMail = result.user.email;

                if (this.$store.getters.userState.userType !== "user") {
                    // caso utente non registrato
                    this.user = this.tempUser;
                } else {
                    // caso utente registrato => chiediamo la login se userData non è più valido
                    // altrimenti simuliamo la login passando il dato tornato dalla chiamata
                    this.showAuthPopup = !this.$store.getters.isUserDataValid;
                    if (!this.showAuthPopup) {
                        this.onUserLogin({
                            token: this.$store.getters.token,
                            user: this.tempUser,
                            userState: this.$store.getters.userState
                        });
                    }
                }

                /*this.$api
                    .getItalyProvinces()
                    .then((result) => {
                        console.debug("GET_ITALY_PROVINCES", result);
                        this.provincesList = result.provinces;
                        this.$api
                            .getItalyCities(this.user.province)
                            .then((result) => {
                                console.debug("GET_ITALY_CITIES", result);
                                this.citiesList = result.cities;
                                for (const city in this.citiesList) {
                                    if (this.user.city === city) {
                                        if (this.citiesList[city].length < 2) {
                                            this.zipList = this.citiesList[
                                                city
                                            ];
                                        } else {
                                            this.zipList = [];
                                            for (const zip in this.citiesList[
                                                city
                                            ]) {
                                                if (
                                                    this.user.zip ===
                                                    this.citiesList[city][zip]
                                                        .cap
                                                ) {
                                                    this.zipList = this.citiesList[
                                                        city
                                                    ];
                                                }
                                            }
                                        }
                                    }
                                }
                            })
                            .catch((error) => {
                                console.error("GET_ITALY_PROVINCES", error);
                                this.$router.push({
                                    name: this.$route.meta.gotoOnAuthFailed,
                                    params: this.$route.params
                                });
                            });
                    })
                    .catch((error) => {
                        console.error("GET_ITALY_PROVINCES", error);
                        this.$router.push({
                            name: this.$route.meta.gotoOnAuthFailed,
                            params: this.$route.params
                        });
                    });
                    */
            })
            .catch((error) => {
                console.error("GET_ACCOUNT_PROFILE", error);
                this.$router.push({
                    name: this.$route.meta.gotoOnAuthFailed,
                    params: this.$route.params
                });
            });
        extend("required", {
            ...required,
            message: this.$t("Campo obbligatorio")
        });
        extend("email", {
            ...email,
            message: this.$t("Inserire una e-mail valida")
        });
        extend("confirmed", {
            ...confirmed,
            validate(value, target) {
                return String(value) === String(target);
            },
            message: this.$t("I campi devono coincidere")
        });
    },
    methods: {
        onChangeCountry() {
            if (
                this.countryList.filter((country) => {
                    return country.name === this.user.state;
                }).length === 0
            ) {
                this.user.state = "";
                this.user.province = "";
                this.user.city = "";
                this.user.zip = "";
                this.onChangeProvince();
                return;
            }

            this.$api
                .getItalyProvinces()
                .then((result) => {
                    console.debug("GET_ITALY_PROVINCES", result);
                    this.provincesList = result.provinces;
                    this.onChangeProvince();
                })
                .catch((error) => {
                    console.error("GET_ITALY_PROVINCES", error);
                    alert("Si è verificato un errore. Riprovare più tardi.");
                    this.$router.push({
                        name: this.$route.meta.gotoOnAuthFailed,
                        params: this.$route.params
                    });
                });
        },

        onChangeProvince() {
            // disabilita gli elementi che dipendono dalla provincia
            this.$refs.province.disabled = true;
            this.$refs.city.disabled = true;
            this.$refs.zip.disabled = true;
            this.$refs.save.disabled = true;
            this.$api
                .getItalyCities(this.user.province)
                .then((result) => {
                    console.debug("GET_ITALY_CITIES", result);
                    this.citiesList = result.cities;
                    this.onChangeCity();
                    // riattiva gli elementi che dipendono dalla provincia
                    this.$refs.province.disabled = false;
                    this.$refs.city.disabled = false;
                    this.$refs.zip.disabled = false;
                    this.$refs.save.disabled = false;
                })
                .catch((error) => {
                    console.error("GET_ITALY_CITIES", error);
                    this.$router.push({
                        name: this.$route.meta.gotoOnAuthFailed,
                        params: this.$route.params
                    });
                });
        },

        onChangeCity() {
            if (this.citiesList[this.user.city]) {
                this.zipList = this.citiesList[this.user.city];
                if (
                    this.zipList.filter((zip) => {
                        return zip.cap === this.user.postalCode;
                    }).length === 0
                ) {
                    this.user.postalCode = "";
                }
            } else {
                this.zipList = [];
                this.user.postalCode = "";
            }
        },

        onCancel() {
            this.$router.push({
                name: "gallery-dashboard",
                params: this.$route.params
            });
        },

        onSubmit() {
            if (
                this.user.email === this.checkMail &&
                this.password === this.checkPassword
            ) {
                this.$api
                    .updateUser({
                        name: this.user.firstName,
                        lastname: this.user.lastName,
                        email: this.user.email,
                        password: this.password,
                        address: this.user.address,
                        state: this.user.state,
                        province: this.user.province,
                        city: this.user.city,
                        zip: this.user.postalCode,
                        tel: this.user.tel
                    })
                    .then((result) => {
                        console.debug("UPDATE_USER", result);
                        alert("I dati sono stati aggiornati");
                    })
                    .catch((error) => {
                        console.error("UPDATE_USER", error);
                        alert(
                            "Si è verificato un errore, i dati non sono stati aggiornati. Riprovare più tardi."
                        );
                    });
            }
        },

        onUserLogin(loginData) {
            //console.debug("USER***", user, this.tempUser, this.user);
            this.$store.dispatch("UPDATE_USER_LOGIN", loginData);
            // recupera lo user dalla variabile temporanea così da visualizzare i dati solo dopo l'avvenuta autenticazione
            this.user = this.tempUser;
            this.showAuthPopup = false;
            this.onChangeCountry();
        },

        onUserLoginClose() {
            this.$router.push({
                name: "gallery-dashboard",
                params: this.$route.params
            });
        }
    }
};
</script>

<style scoped>
</style>
